import React, { useEffect } from 'react';

const PrivacyPolicyView: React.FC = () => {
  useEffect(() => {
    document.documentElement.style.overflow = 'auto';
    document.body.style.overflow = 'auto';
    const root = document.getElementById('root');
    if (root) root.style.overflow = 'auto';
    return () => {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      if (root) root.style.overflow = '';
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0a1628] text-[#c8daf5] py-16 px-4">
      <div className="max-w-3xl mx-auto">

        {/* Header */}
        <div className="mb-12 text-center">
          <img src="/images/logo-orion.png" alt="ORION CRM" className="h-10 w-auto mx-auto mb-6 opacity-80" />
          <h1 className="text-3xl font-black text-white mb-3">Politique de confidentialité</h1>
          <p className="text-sm text-[#546a96]">Version 1.0 — En vigueur depuis le 4 avril 2026</p>
          <div className="mt-6 h-px bg-gradient-to-r from-transparent via-[rgba(100,140,210,0.3)] to-transparent" />
        </div>

        <div className="space-y-10 text-sm leading-relaxed">

          {/* 1. Responsable */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">1</span>
              Responsable du traitement
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-1">
              <p>Le responsable du traitement des données personnelles collectées via Orion CRM est la société éditrice du logiciel.</p>
              <p>Pour toute question relative à vos données : <a href="mailto:contact@crm-orion.com" className="text-[#11c5d6] hover:underline">contact@crm-orion.com</a></p>
            </div>
          </section>

          {/* 2. Données collectées */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">2</span>
              Données personnelles collectées
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-3">
              <div>
                <p className="font-bold text-[#c8daf5] mb-1">Utilisateurs (agents, administrateurs) :</p>
                <ul className="list-disc list-inside space-y-0.5 ml-2">
                  <li>Nom et prénom</li>
                  <li>Adresse email professionnelle</li>
                  <li>Mot de passe (hashé bcrypt — non lisible)</li>
                  <li>Rôle dans l'organisation</li>
                  <li>Date de dernière connexion</li>
                  <li>Adresse IP et journaux d'activité</li>
                </ul>
              </div>
              <div>
                <p className="font-bold text-[#c8daf5] mb-1">Prospects / Leads :</p>
                <ul className="list-disc list-inside space-y-0.5 ml-2">
                  <li>Nom et prénom</li>
                  <li>Email et téléphone</li>
                  <li>Nom de l'entreprise cliente</li>
                  <li>Informations commerciales (statut, chiffre d'affaires potentiel)</li>
                  <li>Commentaires et historique d'activité</li>
                </ul>
              </div>
              <div>
                <p className="font-bold text-[#c8daf5] mb-1">Données techniques :</p>
                <ul className="list-disc list-inside space-y-0.5 ml-2">
                  <li>Adresses IP des connexions</li>
                  <li>Navigateur et système d'exploitation (user-agent)</li>
                  <li>Journaux d'audit des actions effectuées</li>
                </ul>
              </div>
            </div>
          </section>

          {/* 3. Finalités */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">3</span>
              Finalités du traitement
            </h2>
            <div className="pl-8 text-[#7f93bc]">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="text-[#546a96] border-b border-[rgba(100,140,210,0.15)]">
                    <th className="text-left py-2 font-black">Finalité</th>
                    <th className="text-left py-2 font-black">Base légale (RGPD art. 6)</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[rgba(100,140,210,0.08)]">
                  <tr><td className="py-2 pr-4">Gestion CRM et pipeline commercial</td><td className="py-2 text-[#546a96]">Contrat (6.1.b)</td></tr>
                  <tr><td className="py-2 pr-4">Authentification et sécurité des accès</td><td className="py-2 text-[#546a96]">Intérêt légitime (6.1.f)</td></tr>
                  <tr><td className="py-2 pr-4">Journalisation et traçabilité des actions</td><td className="py-2 text-[#546a96]">Intérêt légitime (6.1.f)</td></tr>
                  <tr><td className="py-2 pr-4">Messagerie interne (communication entre utilisateurs)</td><td className="py-2 text-[#546a96]">Intérêt légitime (6.1.f)</td></tr>
                  <tr><td className="py-2 pr-4">Envoi de notifications par email</td><td className="py-2 text-[#546a96]">Consentement (6.1.a)</td></tr>
                  <tr><td className="py-2 pr-4">Amélioration du service</td><td className="py-2 text-[#546a96]">Intérêt légitime (6.1.f)</td></tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 4. Durée de conservation */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">4</span>
              Durée de conservation
            </h2>
            <div className="pl-8 text-[#7f93bc]">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="text-[#546a96] border-b border-[rgba(100,140,210,0.15)]">
                    <th className="text-left py-2 font-black">Donnée</th>
                    <th className="text-left py-2 font-black">Durée</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[rgba(100,140,210,0.08)]">
                  <tr><td className="py-2 pr-4">Comptes utilisateurs</td><td className="py-2 text-[#546a96]">Durée de l'abonnement + 3 ans</td></tr>
                  <tr><td className="py-2 pr-4">Données prospects</td><td className="py-2 text-[#546a96]">Durée de l'abonnement</td></tr>
                  <tr><td className="py-2 pr-4">Messages de la messagerie interne</td><td className="py-2 text-[#546a96]">90 jours par défaut (configurable par l'administrateur, purge automatique)</td></tr>
                  <tr><td className="py-2 pr-4">Journaux d'audit</td><td className="py-2 text-[#546a96]">12 mois (purge automatique)</td></tr>
                  <tr><td className="py-2 pr-4">Tokens de session</td><td className="py-2 text-[#546a96]">1 heure (access) / 30 jours (refresh)</td></tr>
                  <tr><td className="py-2 pr-4">Consentements RGPD</td><td className="py-2 text-[#546a96]">Durée de l'abonnement + 3 ans (preuve légale)</td></tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 4bis. Messagerie interne — information préalable (art. 12 RGPD) */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">4bis</span>
              Messagerie interne — information préalable
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-2 text-xs">
              <p>
                Orion CRM intègre une messagerie interne permettant aux utilisateurs d'une même
                entreprise de communiquer entre eux. Conformément à l'art. 12 RGPD et à la
                jurisprudence française en matière de surveillance des communications professionnelles,
                vous êtes informé des conditions suivantes :
              </p>
              <ul className="space-y-1.5 pl-2">
                <li><strong className="text-[#c8daf5]">Cloisonnement :</strong> vos messages ne sortent jamais de votre entreprise.</li>
                <li>
                  <strong className="text-[#c8daf5]">Lecture par les managers :</strong> par défaut,
                  votre responsable hiérarchique direct peut être ajouté en <strong>observateur</strong>
                  (avec icône 👁️ visible) aux conversations impliquant un membre de son équipe. Il peut
                  lire ces messages mais pas y écrire. Cette visibilité est :
                  <ul className="mt-1 ml-4 space-y-0.5 text-[11px]">
                    <li>• <strong>désactivable</strong> au niveau de l'entreprise par l'administrateur</li>
                    <li>• <strong>contournable</strong> à la création d'une conversation en cochant « Conversation privée » (les observateurs ne sont alors pas ajoutés)</li>
                  </ul>
                </li>
                <li>
                  <strong className="text-[#c8daf5]">Conservation :</strong> les messages sont conservés
                  90 jours par défaut puis purgés automatiquement. Cette durée peut être ajustée par
                  l'administrateur de votre entreprise (entre quelques jours et plusieurs mois).
                </li>
                <li>
                  <strong className="text-[#c8daf5]">Modération :</strong> l'administrateur de votre
                  entreprise peut supprimer un message inapproprié (l'action est tracée dans le journal
                  d'audit avec l'identifiant de l'admin et la date).
                </li>
                <li>
                  <strong className="text-[#c8daf5]">Notifications email :</strong> si vous recevez un
                  message alors que vous êtes hors-ligne, un email récapitulatif peut vous être envoyé
                  (max 1 par heure et par conversation). Vous pouvez désactiver cette fonctionnalité
                  dans votre profil utilisateur.
                </li>
                <li>
                  <strong className="text-[#c8daf5]">Effacement :</strong> en cas de demande d'effacement
                  RGPD, l'identifiant de l'auteur des messages est anonymisé (« ANONYMIZED »), mais le
                  contenu des messages reste visible pour les autres participants à la conversation.
                </li>
              </ul>
            </div>
          </section>

          {/* 5. Droits */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">5</span>
              Vos droits (RGPD)
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-2">
              <p>Conformément au Règlement (UE) 2016/679, vous disposez des droits suivants :</p>
              <ul className="space-y-1.5">
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit d'accès (art. 15)</strong> : obtenir une copie de vos données personnelles.</span></li>
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit de rectification (art. 16)</strong> : corriger des données inexactes.</span></li>
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit à l'effacement (art. 17)</strong> : demander la suppression de vos données.</span></li>
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit à la portabilité (art. 20)</strong> : recevoir vos données dans un format structuré.</span></li>
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit d'opposition (art. 21)</strong> : vous opposer à certains traitements.</span></li>
                <li className="flex items-start gap-2"><span className="text-[#11c5d6] font-black flex-shrink-0">→</span><span><strong className="text-[#c8daf5]">Droit de retrait du consentement (art. 7)</strong> : retirer votre consentement à tout moment.</span></li>
              </ul>
              <p className="mt-3">Pour exercer ces droits, contactez votre administrateur Orion CRM ou écrivez à : <a href="mailto:contact@crm-orion.com" className="text-[#11c5d6] hover:underline">contact@crm-orion.com</a></p>
              <p>Vous pouvez également introduire une réclamation auprès de la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#11c5d6] hover:underline">CNIL</a>.</p>
              <p className="text-[11px] text-[#546a96]">Délai de réponse : 1 mois maximum (art. 12 RGPD), extensible à 3 mois en cas de complexité.</p>
            </div>
          </section>

          {/* 6. Sécurité */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">6</span>
              Sécurité des données
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-1">
              <p>Orion CRM met en œuvre les mesures techniques et organisationnelles suivantes :</p>
              <ul className="list-disc list-inside space-y-0.5 ml-2 mt-1">
                <li>Chiffrement des mots de passe (bcrypt)</li>
                <li>Authentification par token JWT avec expiration courte</li>
                <li>Cookies de session HttpOnly et Secure</li>
                <li>Protection contre les tentatives de connexion en masse (rate-limiting)</li>
                <li>Headers de sécurité HTTP (CSP, HSTS, X-Frame-Options)</li>
                <li>Journalisation de toutes les actions sensibles</li>
                <li>Scan antiviral des fichiers uploadés</li>
              </ul>
            </div>
          </section>

          {/* 7. Cookies */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">7</span>
              Cookies
            </h2>
            <div className="pl-8 text-[#7f93bc]">
              <p>Orion CRM n'utilise que des cookies strictement nécessaires au fonctionnement du service :</p>
              <table className="w-full text-xs border-collapse mt-2">
                <thead>
                  <tr className="text-[#546a96] border-b border-[rgba(100,140,210,0.15)]">
                    <th className="text-left py-2 font-black">Cookie</th>
                    <th className="text-left py-2 font-black">Finalité</th>
                    <th className="text-left py-2 font-black">Durée</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[rgba(100,140,210,0.08)]">
                  <tr><td className="py-2 pr-4 font-mono text-[10px]">refresh_token</td><td className="py-2 text-[#546a96]">Maintien de session (HttpOnly)</td><td className="py-2 text-[#546a96]">30 jours</td></tr>
                </tbody>
              </table>
              <p className="mt-2 text-[11px] text-[#546a96]">Aucun cookie analytique, publicitaire ou tiers n'est utilisé. Aucun consentement cookie n'est requis.</p>
            </div>
          </section>

          {/* 8. Sous-traitants */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">8</span>
              Sous-traitants
            </h2>
            <div className="pl-8 text-[#7f93bc]">
              <p>Les sous-traitants suivants peuvent avoir accès à des données personnelles dans le cadre de la fourniture du service :</p>
              <ul className="list-disc list-inside space-y-0.5 ml-2 mt-1">
                <li>Hébergeur web (infrastructure serveur) — Union Européenne</li>
                <li>Prestataire SMTP (envoi d'emails transactionnels) — Union Européenne</li>
              </ul>
              <p className="mt-2 text-[11px] text-[#546a96]">Chaque sous-traitant est lié par un accord de traitement de données (DPA) conformément à l'art. 28 RGPD.</p>
            </div>
          </section>

          {/* 9. Contact */}
          <section>
            <h2 className="text-base font-black text-white mb-3 flex items-center gap-2">
              <span className="w-6 h-6 rounded-full bg-[rgba(17,197,214,0.15)] text-[#11c5d6] text-[10px] font-black flex items-center justify-center flex-shrink-0">9</span>
              Contact & réclamations
            </h2>
            <div className="pl-8 text-[#7f93bc] space-y-1">
              <p>Pour toute question relative à cette politique ou à vos données personnelles :</p>
              <p><strong className="text-[#c8daf5]">Email :</strong> <a href="mailto:contact@crm-orion.com" className="text-[#11c5d6] hover:underline">contact@crm-orion.com</a></p>
              <p>En cas de litige non résolu, vous pouvez saisir la <strong className="text-[#c8daf5]">CNIL</strong> :<br />
                Commission Nationale de l'Informatique et des Libertés<br />
                3 place de Fontenoy — TSA 80715 — 75334 Paris Cedex 07<br />
                <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-[#11c5d6] hover:underline">www.cnil.fr</a>
              </p>
            </div>
          </section>

        </div>

        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-[rgba(100,140,210,0.15)] text-center">
          <p className="text-[10px] text-[#3d5280]">Orion CRM — Politique de confidentialité v1.0 — 4 avril 2026</p>
          <a href="/" className="text-[11px] text-[#546a96] hover:text-[#11c5d6] transition-colors mt-2 inline-block">← Retour à la connexion</a>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyView;
